var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.slideInClass }, [
    _c("header", [
      _c("div", { staticClass: "close-container" }, [
        _c(
          "a",
          {
            attrs: { href: "#" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.close(false)
              }
            }
          },
          [_c("Icon", { attrs: { icon: "close" } })],
          1
        )
      ]),
      _vm._v(" "),
      _c("h4", { domProps: { innerHTML: _vm._s(_vm.computedTitle) } }),
      _vm._v(" "),
      _vm.withKeyword
        ? _c(
            "div",
            { staticClass: "characteristic-fan--search" },
            [
              _c("SearchInput", {
                attrs: {
                  placeholder:
                    _vm.keywordPlaceholder || "Suche... (mind. 3 Zeichen)",
                  "characteristic-type": _vm.characteristicType,
                  catalog: _vm.searchConfig
                    ? _vm.searchConfig.catalog
                    : undefined
                },
                model: {
                  value: _vm.keyword,
                  callback: function($$v) {
                    _vm.keyword = $$v
                  },
                  expression: "keyword"
                }
              })
            ],
            1
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("main", { staticClass: "scrollbar-check" }, [
      _c(
        "div",
        { staticClass: "items" },
        [
          _vm.isNothingAllowed
            ? _c("CharacteristicItem", {
                attrs: {
                  characteristic: _vm.characteristic,
                  level: _vm.level,
                  nothing: ""
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.childrenGroupedByLetter, function(itemGroup) {
            return _c(
              "div",
              { key: itemGroup.id },
              [
                itemGroup.separation
                  ? _c("Separation", {
                      staticClass: "items-separation",
                      attrs: { separation: itemGroup.separation }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(itemGroup.items, function(characteristics, letter) {
                  return _c(
                    "div",
                    { key: letter, staticClass: "letter-section" },
                    [
                      _c("div", { staticClass: "letter" }, [
                        _vm._v(_vm._s(letter))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "items" },
                        _vm._l(characteristics, function(child) {
                          return _c("CharacteristicItem", {
                            key: child.id,
                            attrs: {
                              characteristic: child,
                              level: _vm.level,
                              keyword: _vm.hasValidKeyword
                                ? _vm.keyword
                                : undefined
                            }
                          })
                        }),
                        1
                      )
                    ]
                  )
                })
              ],
              2
            )
          })
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c(
      "footer",
      [
        _c("Button", {
          attrs: { text: "OK", icon: "checkmark", disabled: !_vm.valid },
          on: {
            click: function($event) {
              return _vm.close(true)
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }